import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00700-conditions-form" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col q-gutter-x-xs flex justify-end" }
const _hoisted_7 = { class: "cmd00700-result-table" }
const _hoisted_8 = { class: "full-width row q-gutter-sm" }
const _hoisted_9 = { class: "q-pt-xs" }
const _hoisted_10 = { class: "add-btn-area flex items-center justify-between filter-select" }
const _hoisted_11 = { class: "flex" }

import { ref } from 'vue';
import Loading from 'quasar/src/plugins/Loading.js';;
import { useRouter } from 'vue-router';
import saveAs from 'file-saver';
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import base64toBlob from '../../common/utils/fileUtils';
import commaFormat from '../../common/utils/numberUtils';
import CategorySelects from '../../components/selects/CategorySelects.vue';
import SupplierSelects from '../../components/selects/SupplierSelects.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';

// カラム表示機能
interface VisibleColumn {
  name: string;
  label: string;
}

// テーブルデータ
interface Rows {
  catalog_id: number;
  sup_category: string;
  supplier_code: string;
  supplier_name: string;
  sup_sdfile_name: string;
  item_num: number;
  poison_num: string;
  ban_num: string;
  special_num: string;
  update_timestamp: Date;
  memo: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00700',
  setup(__props) {

const router = useRouter();

// 検索条件：サプライヤ
const supplier = ref('');
// 検索条件：カテゴリー
const category = ref('');
// 検索条件：ワード検索
const word = ref('');
// カタログID
const catalogId = ref('');

// 保持用検索条件：サプライヤ
const saveSupplier = ref('');
// 保持用検索条件：カテゴリー
const saveCategory = ref('');
// 保持用検索条件：ワード検索
const saveWord = ref('');

// 表示カラム
const visibleColumns = ref<Array<string>>([]);
// カラム表示設定の選択肢
const visibleColumnOptions = ref<Array<VisibleColumn>>([]);
// テーブルメッセージ
const tableMessage = ref('検索してください。');

// Dialogタイトル
const dialogTitle = ref('');
// Dialog表示レベル
const dialogLevel = ref('');
// Dialog本文
const dialogText = ref(['']);
// 確認Dialogフラグ
const isConfFlg = ref(false);
// 削除確認Dialog表示フラグ
const isDeleteDialog = ref(false);
// Excel出力確認Dialog表示フラグ
const isOutExcelDialog = ref(false);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns: Array<any> = [
  {
    name: 'editDelete',
    field: (row: Rows) => row.catalog_id,
    required: true,
  },
  {
    name: 'catalog_id',
    label: ' カタログID',
    align: 'left',
    field: (row: Rows) => row.catalog_id,
    sortable: true,
    classes: 'text-right',
  },
  {
    name: 'sup_category',
    label: 'カテゴリー',
    align: 'left',
    field: (row: Rows) => row.sup_category,
    sortable: true,
  },
  {
    name: 'supplier_code',
    label: 'サプライヤコード',
    align: 'left',
    field: (row: Rows) => row.supplier_code,
    sortable: true,
  },
  {
    name: 'supplier_name',
    label: 'サプライヤ名',
    align: 'left',
    field: (row: Rows) => row.supplier_name,
    sortable: true,
  },
  {
    name: 'sup_sdfile_name',
    label: 'SDFile名',
    align: 'left',
    field: (row: Rows) => row.sup_sdfile_name,
    sortable: true,
  },
  {
    name: 'item_num',
    label: '品目数',
    align: 'left',
    field: (row: Rows) => (row.item_num ? commaFormat(row.item_num) : 0),
    classes: 'text-right',
    sortable: true,
    style: 'min-width: 120px',
  },
  {
    name: 'poison_num',
    label: '毒劇品目数',
    align: 'left',
    field: (row: Rows) => (row.poison_num ? commaFormat(Number(row.poison_num)) : '未実施'),
    classes: 'text-right',
    sortable: true,
    style: 'min-width: 120px',
  },
  {
    name: 'ban_num',
    label: '輸入禁止品目数',
    align: 'left',
    field: (row: Rows) => (row.ban_num ? commaFormat(Number(row.ban_num)) : '未実施'),
    classes: 'text-right',
    sortable: true,
    style: 'min-width: 120px',
  },
  {
    name: 'special_num',
    label: '法規制チェックエラー品目数',
    align: 'left',
    field: (row: Rows) => (row.special_num ? commaFormat(Number(row.special_num)) : '未実施'),
    classes: 'text-right',
    sortable: true,
    style: 'min-width: 120px',
  },
  {
    name: 'update_timestamp',
    label: '更新日時',
    align: 'left',
    field: (row: Rows) => row.update_timestamp,
    sortable: true,
    style: 'width: 170px',
  },
  {
    name: 'memo',
    label: '備考',
    align: 'left',
    field: (row: Rows) => row.memo,
    sortable: true,
  },
];

// 検索結果
const data = ref<Rows[]>([]);

/**
 * SDFile削除確認ダイアログ表示
 * @param {string} catalog カタログID
 */
const displayDeleteSdfDialog = (catalog: string) => {
  catalogId.value = catalog;
  dialogTitle.value = '削除確認';
  dialogLevel.value = 'warning';
  dialogText.value = [
    `カタログID:${catalog}に紐づく商品データをすべて削除します。`,
    '本当によろしいですか？',
  ];
  isConfFlg.value = false;
  isDeleteDialog.value = true;
};

/**
 * Excel出力確認ダイアログ表示
 */
const displayOutExcelDialog = () => {
  dialogTitle.value = 'Excel出力確認';
  dialogLevel.value = 'information';
  dialogText.value = ['検索結果のExcelファイルを出力します。', 'よろしいですか？'];
  isConfFlg.value = false;
  isOutExcelDialog.value = true;
};

/**
 * フォーム初期化
 */
const resetForm = () => {
  category.value = '';
  supplier.value = '';
  word.value = '';
};

/**
 * SDFileリスト検索
 */
const searchSdfList = async () => {
  // Loading Start
  Loading.show();
  // 検索用データ作成
  const formData = new FormData();
  formData.append('supplier_code', supplier.value);
  formData.append('category_id', category.value);
  formData.append('word', word.value);

  // 保持用のデータを設定
  saveSupplier.value = supplier.value;
  saveCategory.value = category.value;
  saveWord.value = word.value;

  // SDFileリスト取得
  await axios
    .post('/cmd007001/search-sdf-list', formData)
    .then((res) => {
      const { common, sdFileList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          data.value = sdFileList;
          tableMessage.value = 'データがありません。';
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * Excel出力
 */
const downloadExcel = async () => {
  // Loading Start
  Loading.show();
  // 検索用データ作成
  const formData = new FormData();
  formData.append('supplier_code', saveSupplier.value);
  formData.append('category_id', saveCategory.value);
  formData.append('word', saveWord.value);

  // SDFileリスト取得
  await axios
    .post('/cmd007001/download-excel', formData)
    .then((res) => {
      const { common, body, file_name } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS: {
          const blob = new Blob(
            [
              base64toBlob(
                body,
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              ),
            ],
            {}
          );
          saveAs(blob, file_name);
          // ダイアログ表示
          dialogTitle.value = 'Excel出力完了';
          dialogLevel.value = 'information';
          dialogText.value = ['検索結果のExcelファイルを出力しました。'];
          isConfFlg.value = true;
          isOutExcelDialog.value = true;
          break;
        }
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * SDFile削除
 */
const deleteSdf = async () => {
  // Loading Start
  Loading.show();
  // 検索用データ作成
  const formData = new FormData();
  formData.append('catalog_id', catalogId.value);
  formData.append('supplier_code', saveSupplier.value);
  formData.append('category_id', saveCategory.value);
  formData.append('word', saveWord.value);

  // SDFile削除
  await axios
    .post('/cmd007001/delete-sdf', formData)
    .then((res) => {
      const { common, sdFileList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          data.value = sdFileList;
          dialogTitle.value = '削除完了';
          dialogLevel.value = 'information';
          dialogText.value = ['削除が完了しました。'];
          isConfFlg.value = true;
          isDeleteDialog.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.UPDATE_ERROR:
              dialogTitle.value = '削除エラー';
              dialogLevel.value = 'error';
              dialogText.value = [common.message];
              isConfFlg.value = true;
              isDeleteDialog.value = true;
              break;
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * SDFile変更画面に遷移
 * @param {number} editCatalogId カタログID
 */
const editData = (editCatalogId: number) => {
  router.push({ name: 'sdfileEdit', params: { catalogId: editCatalogId } });
};

/**
 * 初期表示処理
 */
// カラム表示設定
for (let i = 0; i < columns.length; i += 1) {
  visibleColumns.value.push(columns[i].name);
  // 編集削除ボタンのカラムは除外
  if (columns[i].name !== 'editDelete') {
    visibleColumnOptions.value.push({
      name: columns[i].name,
      label: columns[i].label,
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[11] || (_cache[11] = [
        _createTextVNode("SDFile一覧")
      ])),
      _: 1
    }),
    _createVNode(_component_q_form, {
      autofocus: "",
      greedy: "",
      onSubmit: _withModifiers(searchSdfList, ["prevent"]),
      onReset: resetForm
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_card, {
            style: {"background":"var(--q-lightGray)"},
            flat: "",
            bordered: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "q-gutter-y-md" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(['row q-gutter-x-xs', !!word.value && 'cmd00700-disable'])
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", null, "サプライヤ", -1)),
                      _createVNode(SupplierSelects, {
                        supplier: supplier.value,
                        disabled: !!word.value,
                        onSelectSupplier: _cache[0] || (_cache[0] = ($event: any) => (supplier.value = $event))
                      }, null, 8, ["supplier", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", null, "カテゴリー", -1)),
                      _createVNode(CategorySelects, {
                        category: category.value,
                        disabled: !!word.value,
                        onSelectCategory: _cache[1] || (_cache[1] = ($event: any) => (category.value = $event))
                      }, null, 8, ["category", "disabled"])
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(['row', (!!category.value || !!supplier.value) && 'cmd00700-disable'])
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", null, "ワード検索", -1)),
                      _createVNode(_component_q_input, {
                        modelValue: word.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((word).value = $event)),
                        outlined: "",
                        dense: "",
                        style: {"background":"var(--q-white)"},
                        class: "input-area",
                        disable: !!category.value || !!supplier.value,
                        maxlength: "200",
                        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                        onClear: _cache[4] || (_cache[4] = ($event: any) => (word.value = ''))
                      }, null, 8, ["modelValue", "disable"]),
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "cmd00700-word-form q-mt-xs flex" }, [
                        _createElementVNode("p", { class: "q-mb-none" }, [
                          _createTextVNode("SDFile名、備考を指定できます。"),
                          _createElementVNode("br")
                        ])
                      ], -1))
                    ])
                  ], 2),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_q_btn, {
                        type: "submit",
                        color: "primary",
                        style: {"width":"150px"},
                        label: "検索",
                        icon: "mdi-magnify"
                      }),
                      _createVNode(_component_q_btn, {
                        type: "reset",
                        outline: "",
                        style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                        icon: "mdi-eraser",
                        label: "クリア"
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area btn-exist table-top-button ' + (data.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-table",
          rows: data.value,
          columns: columns,
          "row-key": "index",
          flat: "",
          dense: "",
          "visible-columns": visibleColumns.value,
          separator: "cell",
          "no-data-label": tableMessage.value,
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "rows-per-page": "20",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_9, _toDisplayString(message), 1)
            ])
          ]),
          top: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_q_select, {
                modelValue: visibleColumns.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((visibleColumns).value = $event)),
                multiple: "",
                outlined: "",
                dense: "",
                "options-dense": "",
                "display-value": "カラム表示設定",
                "emit-value": "",
                "map-options": "",
                options: visibleColumnOptions.value,
                "option-value": "name",
                color: "primary",
                class: "column-disp"
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("div", null, [
                _createVNode(_component_q_btn, {
                  color: "primary",
                  class: _normalizeClass(
                    'export-btn excel-exportbtn ' +
                    (data.value.length === 0 ? 'cmd00700-disabled-btn' : '')
                  ),
                  outline: data.value.length !== 0 ? true : false,
                  icon: "mdi-download",
                  "no-caps": "",
                  disable: data.value.length === 0,
                  onClick: displayOutExcelDialog
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode("Excel出力")
                  ])),
                  _: 1
                }, 8, ["class", "outline", "disable"]),
                (data.value.length === 0)
                  ? (_openBlock(), _createBlock(_component_q_tooltip, {
                      key: 0,
                      anchor: "top middle",
                      self: "bottom middle",
                      offset: [15, 15]
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createElementVNode("strong", null, "検索結果が存在しません", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          "header-cell-editDelete": _withCtx(() => [
            _createVNode(_component_q_th, { class: "table-btn-area delete-btn-exists" })
          ]),
          "body-cell-editDelete": _withCtx((cell) => [
            _createVNode(_component_q_td, { class: "table-btn-area delete-btn-exists" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_q_btn, {
                    icon: "mdi-pencil",
                    label: "編集",
                    color: "primary",
                    onClick: ($event: any) => (editData(cell.row.catalog_id))
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_q_btn, {
                    icon: "mdi-close",
                    label: "削除",
                    class: "deletebtn",
                    outline: "",
                    color: "primary",
                    style: {"color":"var(--q-delete)"},
                    onClick: ($event: any) => (displayDeleteSdfDialog(cell.row.catalog_id))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["rows", "visible-columns", "no-data-label", "pagination-label"])
      ], 2)
    ]),
    _createVNode(AlertDialog, {
      display: isDeleteDialog.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[6] || (_cache[6] = ($event: any) => (isDeleteDialog.value = false)),
      onConfirm: deleteSdf,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (isDeleteDialog.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isOutExcelDialog.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[8] || (_cache[8] = ($event: any) => (isOutExcelDialog.value = false)),
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (downloadExcel())),
      onClose: _cache[10] || (_cache[10] = ($event: any) => (isOutExcelDialog.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"])
  ]))
}
}

})